import { Component, OnInit } from '@angular/core';

import { ModalController, NavParams } from '@ionic/angular';
import { lastDayOfMonth, startOfMonth, subMonths } from 'date-fns';
import { Subject, debounceTime, distinctUntilChanged } from 'rxjs';
import { DevUtils } from 'src/providers/apiservices/Utils';
import { GlobalService, ToastColors } from 'src/providers/apiservices/globalservices';

export class SelectSearchableItem {
  id: string;
  texto: string;
  isVisivel: boolean = true;
  obj: any;

  constructor(id: string, texto: string, obj: any) {
    this.id = id;
    this.texto = texto;
    this.obj = obj;
  }
}
type User = {
  email: string;
  nomUsuario: string;
  login1: string;
  id: string;
  texto: string;
}
export class SelectSearchableItemPaginate {
  user: User;
  login1: any

  constructor(user: User) {
    this.user = user;
  }
}

@Component({
  selector: 'app-select-searchable',
  templateUrl: './select-searchable.page.html',
  styleUrls: ['./select-searchable.page.scss'],
})
export class SelectSearchablePage implements OnInit {
  
  titulo: string = '';
  type: string = 'DEFAULT';
  descricao: string = '';
  filtro: string = '';
  filtroUpdate = new Subject<string>();
  lista: Array<SelectSearchableItem> = [];
  listaFiltrando: Array<SelectSearchableItem> = [];

  maxsize: number = 1;
  selecionados: Array<SelectSearchableItem> = [];
  isPaginate: boolean = false;
  isLoadingSearch = false;
  canSeeBoletosContratosRescindidos = false;
  provider: any;

  // TYPE: SELECT_CONTRATOS
  _isFilterByContratosRescindidos: boolean = false;

  public get isFilterByContratosRescindidos(): boolean {
    return this._isFilterByContratosRescindidos;
  }

  public set isFilterByContratosRescindidos(value: boolean)
  {
    this.filtro = "";

    if(this.selecionados.length)
      this.selecionados.forEach(it => this.deselect(it))

    this.filterStoreDtRescisao(value);

    this._isFilterByContratosRescindidos = value;
    
  }

  filterStoreDtRescisao(isFilterByContratosRescindidos = false, item = null)
  {
    var lastDayOfPastMonth = lastDayOfMonth(subMonths(new Date(), 1));
    var primeiroDiaDoMesAtual = startOfMonth(new Date());

    if(isFilterByContratosRescindidos)
    {
      this.listaFiltrando = this.lista
      .filter(x => x.obj.dtRescisao != null)
      .filter(x => {
        return new Date(x.obj.dtRescisao) <= x.obj.idEmpresaNavigation.dtAberturaAdm;
      });
    }
    else
    {
      this.listaFiltrando = this.lista.filter(x => {
        if(x.obj.dtRescisao == null)
          return true;

        return new Date(x.obj.dtRescisao) >= primeiroDiaDoMesAtual;
      } );
    }
  }

  applyFilter(_lista: Array<SelectSearchableItem>): Array<SelectSearchableItem>
  {
    var lastDayOfPastMonth = lastDayOfMonth(subMonths(new Date(), 1));
    var primeiroDiaDoMesAtual = startOfMonth(new Date());

    if(this._isFilterByContratosRescindidos)
    {
      return _lista
      .filter(x => x.obj.dtRescisao != null)
      .filter(x => {
        return new Date(x.obj.dtRescisao) < primeiroDiaDoMesAtual
      });
    }
    else
    {
      return _lista.filter(x => {
        if(x.obj.dtRescisao == null)
          return true;

        return new Date(x.obj.dtRescisao) >= primeiroDiaDoMesAtual;
      } );
    }
  }

  constructor(
    public modalController: ModalController,
    private navParams: NavParams,
    private globalService:GlobalService
    ) { 
      this.titulo = this.navParams.data.titulo;
      this.type = this.navParams.data.type;
      this.descricao = this.navParams.data.descricao;
      this.filtro = this.navParams.data.filtro;
      this._isFilterByContratosRescindidos = this.navParams.data.isContratosRescindidos || false;
      this.canSeeBoletosContratosRescindidos = this.navParams.data.canSeeBoletosContratosRescindidos || false;
      this.lista = this.navParams.data.lista;
      this.maxsize = this.navParams.data.maxsize;
      this.selecionados = [];
      let temp = this.navParams.data.selecionados;

      this.search();
      this.setSelected(temp);

    }

  ngOnInit() {
    this.filtroUpdate
      .pipe(debounceTime(400), distinctUntilChanged())
      .subscribe((_) => {
        this.isLoadingSearch = false;
        this.search();
      });
   }

  dismiss(salvar: boolean) {
    this.modalController.dismiss({
      'selecionados': this.selecionados,
      'salvar': salvar,
      ...this.type == 'SELECT_CONTRATOS' && ({isContratosRescindidos: this._isFilterByContratosRescindidos})
    });
  }

  get isUserSelect(): boolean {
    return this.isPaginate && this.provider;
  }

  filterByContratosRescindidos(listaArrayItem: SelectSearchableItem): boolean
  {
    if(this.type !== 'SELECT_CONTRATOS')
      return true;

    var lastDayOfPastMonth = lastDayOfMonth(subMonths(new Date(), 1));
    var primeiroDiaDoMesAtual = startOfMonth(new Date());

    return this.isFilterByContratosRescindidos ? 
      (listaArrayItem.obj.dtRescisao != null && new Date(listaArrayItem.obj.dtRescisao) < primeiroDiaDoMesAtual) 
      : listaArrayItem.obj.dtRescisao == null || (listaArrayItem.obj.dtRescisao == null && new Date(listaArrayItem.obj.dtRescisao) >= primeiroDiaDoMesAtual );
  }

  search(){
    var me = this;

    if(this.isPaginate && this.provider)
    {
      this.provider.getMultiplanUsers({
        operacao: "page",
        rowsPerPage: 100,
        tipoUsuario: 2,
        searchString: this.filtro.trim()
      })
      .then(res => {
        //console.log("Res", res);
      })


      return;
    }

    this.listaFiltrando = this.applyFilter(this.filtro ? DevUtils.searchInArray(this.lista, this.filtro, ['texto']) : this.lista);

    if(this.listaFiltrando.length === 0 && this._isFilterByContratosRescindidos === true && this.filtro.length >= 8 && !isNaN(Number(this.filtro.trim())))
    {
      let numero = parseInt(this.filtro.trim());
      let item = this.lista.find(item => item.obj.numContrato.includes(numero));
      
      if(item)
      {
        this.globalService.presentToast(`Contrato ${item.obj.numContrato} ativo. Para visualizar desmarque a opção "Contrato Rescindido".`)
      }
    }

  }

  setSelected(data?: SelectSearchableItem[]){
    if(data == undefined) {
      this.selecionados = [];
    }
    else{
      data.forEach(element => {
        let item = this.listaFiltrando.find(item => element.id === item.id);
        if(item){
          this.selecionados.push(item);
          item.isVisivel = false;
        }
      });
    }
  }

  select(item : SelectSearchableItem) {
    if(item.id === 'SELECT_ALL')
    {
      if(this.lista.length == this.selecionados.length)
      {
        this.selecionados = []
        return;
      }

      if(this.selecionados.length >= this.maxsize) {
        return this.globalService.presentToast('Selecione no máximo ' + this.maxsize + " items!", ToastColors.warning);
      }

      this.selecionados = this.lista.filter(x => x.id !== "SELECT_ALL");

      return;
    }

    if(this.maxsize === 1 && this.selecionados.length > 0)
    {
      const _previousItem = this.selecionados[0];

      if(_previousItem)
      {

        const _previousItemIndex = this.lista.findIndex(x => x.id === _previousItem.id);

        if(_previousItemIndex !== -1)
        {
          this.lista[_previousItemIndex].isVisivel = true;
        }
      }

      this.selecionados = [];
      this.selecionados.push(item);
      item.isVisivel = false;
      return; 
    }

    if(this.selecionados.length >= this.maxsize) {
      this.globalService.presentToast('Selecione no máximo ' + this.maxsize + " items!", ToastColors.warning);
    } else {
      
      const _previousItem = this.selecionados.find(u => u.id == item.id);

      if(_previousItem)
      {
        const _previousItemIndex = this.lista.findIndex(x => x.id === _previousItem.id);

        if(_previousItemIndex !== -1)
        {
          this.lista[_previousItemIndex].isVisivel = true;
        }
      }

      this.selecionados.push(item);
      item.isVisivel = false;
    }
  }

  deselect(item : SelectSearchableItem){

    if(item.id === 'SELECT_ALL')
    {
      this.selecionados = []
      return;
    }

    let selected = this.listaFiltrando.find(element => element.id === item.id);
    if(selected)
      selected.isVisivel = true;
      
    this.selecionados = this.selecionados.filter(function(a){return a.id !== item.id});
  }
}
